import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useRoot } from "../../../context/root"

export const useLayout = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const { 
    dataMarkers: data, 
    showSearchInThisArea, 
    previousApp,
    extraMarker
  } = useRoot();
  const [openClaimInfoModal, setOpenClaimInfoModal] = useState(!!searchParams.get("claim"));

  const redirectToPreviousApp = (url: string) => {
    window.location.href = url
  }

  const generatePseudorandomString = (length: number) => {
    const chars = '0123456789qwertyuioplkjhgfdsazxcvbnm';
    return Array.from(Array(length)).reduce((prev: string) => {
      return prev + chars.charAt(Math.floor(Math.random() * chars.length))
    }, '')
  }

  return {
    data,
    showSearchInThisArea,
    generatePseudorandomString,
    goBackTo: {
      appName: previousApp?.appName || "DoveMed",
      onClick: () => redirectToPreviousApp(previousApp?.url || window.location.origin)
    },
    extraMarker,
    openClaimInfoModal,
    setOpenClaimInfoModal,
  }
}
